// @ts-nocheck
import { useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap-v5";
import Select from 'react-select'
import { ToastContainer } from 'react-toastify';
import ExpenseReport from '../components/ExpenseReport';
import MonthlyExpenseReport from '../components/MonthlyExpenseReport';
import ExpenseSummaryReport from '../components/ExpenseSummaryReport';
import SalespersonWiseSalesReport from '../components/SalespersonWiseSalesReport';
import CompanyWiseProductReport from '../components/CompanyWiseProductReport';
import ProductWiseSalesReport from '../components/ProductWiseSalesReport';
import SalesReport from '../components/SalesReport';
import SalesReportV2 from '../components/SalesReportV2';
import DueReport from '../components/DueReport';
import SalesAdvanceReceiveReport from '../components/SalesAdvanceReceiveReport';
import SalespersonActivitesReport from '../components/SalespersonActivitesReport';
import SalespersonPerformanceReport from '../components/SalespersonPerformanceReport';
import DeliveryReport from '../components/DeliveryReport';
import OrderSheetReport from '../components/OrderSheetReport';
import SalesOrdersPendingDeliveryReport from '../components/SalesOrdersPendingDeliveryReport';
import LedgerStatementReport from '../components/LedgerStatementReport';
import DayBookReport from '../components/DayBookReport';
import PaymentSummaryReport from '../components/PaymentSummaryReport';
import CostBreakupReport from '../components/CostBreakupReport';
import ProfitAndLossReport from '../components/ProfitAndLossReport';
import CompanyWiseSalesReport from '../components/CompanyWiseSalesReport';
import CollectionReport from '../components/CollectionReport';
import CollectionReportV2 from '../components/CollectionReportV2';
import InvoiceHistoryReport from '../components/InvoiceHistoryReport';
import CustomerEdgingReport from '../components/CustomerEdgingReport';
import CustomerOutstandingAgingReport from '../components/CustomerOutstandingAgingReport';
import CostOfGoodsSoldReport from '../components/CostOfGoodsSoldReport';

import ItemWisePurchaseReport from '../components/ItemWisePurchaseReport';
import DetailPurchaseItemSearch from '../components/DetailPurchaseItemSearch';
import DetailSalesItemSearch from '../components/DetailSalesItemSearch';
import FreeSalesItemSearch from '../components/FreeSalesItemSearch';
import ExpectedStockReport from '../components/ExpectedStockReport';
import WarehouseStockReport from '../components/WarehouseStockReport';
import ActualExpectedStockReport from '../components/ActualExpectedStockReport';
import StockUsagePrediction from '../components/StockUsagePrediction';
import StockAgingReport from '../components/StockAgingReport';
import RawMaterialInOutReport from '../components/RawMaterialInOutReport';
import MonthlyProductionReport from '../components/MonthlyProductionReport';
import ProductionDetailsReport from '../components/ProductionDetailsReport';
import ItemRateHistoryReport from '../components/ItemRateHistoryReport';
import GroupWiseBalanceReport from '../components/GroupWiseBalanceReport';
import BankReconciliationReport from '../components/BankReconciliationReport';

import GetPagePermission from "../components/GetPagePermission";
import { useLocation } from "react-router-dom";

export default function Reports() {

    const hasExpensePermission = GetPagePermission("/expense-report");
    const hasMonthlyExpensePermission = GetPagePermission("/monthly-expense-report");
    const hasSalesPermission = GetPagePermission("/industrial-sales-report");
    const hasAllSalesPermission = GetPagePermission("/all-sales-report-v2");
    const hasDeliveryPermission = GetPagePermission("/delivery-report");
    const hasLedgerStatementPermission = GetPagePermission("/ledger-statement");
    const hasTrialBalancePermission = GetPagePermission("/trial-balance");
    const hasReconciliationPermission = GetPagePermission("/reconciliation");
    const hasDayBookPermission = GetPagePermission("/day-book");
    const hasCostBreakupPermission = GetPagePermission("/cost-breakup");
    const hasProfitAndLossReportPermission = GetPagePermission("/profit-loss");
    const hasOrderSheetPermission = GetPagePermission("/order-sheet-report");
    const hasSalesOrderPendingDeliveryPermission = GetPagePermission("/sales-order-pending-delivery");
    const hasDueReportPermission = GetPagePermission("/due-report");
    const hasSalesAdvanceReceivePermission = GetPagePermission("/sales-advance-receive-report");
    const hasCompanyWiseSalesReportPermission = GetPagePermission("/company-wise-sales-report");
    const hasCollectionReportPermission = GetPagePermission("/collection-report");

    
    const hasSalespersonActivitesReportPermission = GetPagePermission("/salesperson-activites-report");
    const hasInvoiceHistoryReportPermission = GetPagePermission("/invoice-history-report");
    const hasSalespersonWiseSalesPermission = GetPagePermission("/salesperson-wise-sales");
    const hasCompanyWiseProductPermission = GetPagePermission("/company-wise-product");
    const hasProductWiseSalesPermission = GetPagePermission("/product-wise-sales");
    const hasCustomerEdgingReportPermission = GetPagePermission("/customer-edging-report");
    const hasCustomerOutstandingAgingPermission = GetPagePermission("/customer-outstanding-aging-report");
    const hasItemWisePurchaseReportPermission = GetPagePermission("/item-wise-purchase-report");
    const hasDetailsPurchaseItemSearchPermission = GetPagePermission("/detail-purchase-item-search");
    const hasDetailsSalesItemSearchPermission = GetPagePermission("/detail-sales-item-search");
    const hasFreeSalesItemSearchPermission = GetPagePermission("/free-sales-item-search");
    const hasCostOfGoodsSoldReportPermission = GetPagePermission("/income-statement");
    const hasExpectedStockReportPermission = GetPagePermission("/expected-stock-status");
    const hasStockUsagePredictionPermission = GetPagePermission("/stock-usage-prediction");
    const hasSrWiseExpenseSummaryPermission = GetPagePermission("/sr-wise-expense-summary");
    const hasMonthlyProductionReportPermission = GetPagePermission("/monthly-production-report");
    const hasProductionDetailsReportPermission = GetPagePermission("/production-details-report");
    const hasPaymentSummaryPermission = GetPagePermission("/payment-summary");
    const hasStockAgingReportPermission = GetPagePermission("/stock-aging-report");
    const hasRawMaterialInOutReportPermission = GetPagePermission("/raw-material-in-out-report");
    const hasItemRateHistoryPermission = GetPagePermission("/item-rate-history-report");
    const hasWarehouseStockReportPermission = GetPagePermission("/warehouse-stock-report");
    // console.log('ddddddddddddd', hasStockUsagePredictionPermission)

    const location = useLocation();
    const query = new URLSearchParams(location.search);

    const [currentReport, setCurrentReport] = useState({ label: 'Select a Report', value: '' });
    const [availableReports, setAvailableReports] = useState([{ label: 'Select a Report', value: '' }]);

    useEffect(() => {
        // Reset updatedReports to contain the default value at the beginning
        const updatedReports = [{ label: 'Select a Report', value: '' }];
        if (hasExpensePermission) {
            updatedReports.push({ label: 'Expense >> Expense Report', value: 'generalExpenseReport' });
        }
        if (hasSrWiseExpenseSummaryPermission) {
            updatedReports.push({ label: 'Expense >> SR Wise Expense Summary', value: 'srWiseExpenseSummary' });
        }
        if (hasSalesPermission) {
            updatedReports.push({ label: 'Sales >> All Sales Report', value: 'generalSalesReport' });
        }

        if (hasAllSalesPermission) {
            updatedReports.push({ label: 'Sales >> All Sales Report V2', value: 'generalSalesReportV2' });
        }

        if (hasDeliveryPermission) {
            updatedReports.push({ label: 'Delivery >> Delivery Report', value: 'generalDeliveryReport' });
        }
        if (hasLedgerStatementPermission) {
            updatedReports.push({ label: 'Accounting >> Ledger Statement', value: 'ledgerStatement' });
        }
        if (hasTrialBalancePermission || hasLedgerStatementPermission) {
            updatedReports.push({ label: 'Accounting >> Group-wise Balance Report', value: 'groupWiseBalanceReport' });
        }
        if (hasReconciliationPermission || hasLedgerStatementPermission) {
            updatedReports.push({ label: 'Accounting >> Bank Reconciliation Statement', value: 'bankReconciliationStatement' });
        }
        if (hasOrderSheetPermission) {
            updatedReports.push({ label: 'Sales >> Order Sheet Report', value: 'orderSheetReport' });
        }
        if (hasSalesOrderPendingDeliveryPermission) {
            updatedReports.push({ label: 'Sales >> Sales Orders Pending Delivery', value: 'salesOrdersPendingDelivery' });
        }
        if (hasDueReportPermission) {
            updatedReports.push({ label: 'Sales >> Due Report', value: 'dueReport' });
        }
        if (hasSalesAdvanceReceivePermission) {
            updatedReports.push({ label: 'Sales >> Sales Advance Receive', value: 'salesAdvanceReceiveReport' });
        }
        if (hasCompanyWiseSalesReportPermission) {
            updatedReports.push({ label: 'Sales >> Company Wise Sales Report', value: 'companyWiseSalesReport' });
        }

        if (hasCollectionReportPermission) {
            updatedReports.push({ label: 'Sales >> Collection Report', value: 'collectionReport' });
        }

        if (hasCollectionReportPermission) {
            updatedReports.push({ label: 'Sales >> Collection Report V2', value: 'collectionReportV2' });
        }

        if (hasSalespersonActivitesReportPermission) {
            updatedReports.push({ label: 'Sales >> Salesperson Activities Report', value: 'salespersonActivitesReport' });
        }

        if (hasSalespersonActivitesReportPermission) {
            updatedReports.push({ label: 'Sales >> Salesperson Activities Report V2', value: 'salespersonPerformanceReport' });
        }

        if (hasInvoiceHistoryReportPermission) {
            updatedReports.push({ label: 'Sales >> Invoice History Report', value: 'invoiceHistoryReport' });
        }

        if (hasSalespersonWiseSalesPermission) {
            updatedReports.push({ label: 'Sales >> Salesperson Wise Product Report', value: 'salespersonWiseSales' });
        }

        if (hasCompanyWiseProductPermission) {
            updatedReports.push({ label: 'Sales >> Company Wise Product Report', value: 'companyWiseProduct' });
        }

        if (hasProductWiseSalesPermission) {
            updatedReports.push({ label: 'Sales >> Product Wise Sales Report', value: 'productWiseSales' });
        }

        if (hasCustomerEdgingReportPermission) {
            updatedReports.push({ label: 'Sales >> Client Edging Report', value: 'customerEdgingReport' });
        }
        if (hasCustomerOutstandingAgingPermission || hasCustomerEdgingReportPermission) {
            updatedReports.push({ label: 'Sales >> Customer Outstanding Aging Report', value: 'customerOutstandingAgingReport' });
        }

        if (hasItemWisePurchaseReportPermission) {
            updatedReports.push({ label: 'Sales >> Item Wise Purchase Report', value: 'itemWisePurchaseReport' });
        }

        if (hasDetailsSalesItemSearchPermission) {
            updatedReports.push({ label: 'Detail Sales Item Search', value: 'detailSalesItemSearch' });
        }
        if (hasFreeSalesItemSearchPermission) {
            updatedReports.push({ label: 'Free Sales Item Search', value: 'freeSalesItemSearch' });
        }

        if (hasDetailsPurchaseItemSearchPermission) {
            updatedReports.push({ label: 'Detail Purchase Item Search', value: 'detailPurchaseItemSearch' });
        }

        if (hasDetailsPurchaseItemSearchPermission) {
            updatedReports.push({ label: 'Accounting >> Cost of goods sold', value: 'costOfGoodsSoldReport' });
        }

        if (hasExpectedStockReportPermission) {
            updatedReports.push({ label: 'Inventory >> Expected Stock Status Report', value: 'expectedStockReport' });
        }

        if (hasExpectedStockReportPermission) {
            updatedReports.push({ label: 'Inventory >> Actual Stock Status Report', value: 'actualExpectedStockReport' });
        }

        if (hasStockUsagePredictionPermission) {
            updatedReports.push({ label: 'Inventory >> Stock Usage Prediction', value: 'stockUsagePrediction' });
        }

        if (hasMonthlyProductionReportPermission) {
            updatedReports.push({ label: 'Production >> Monthly Production Report', value: 'monthlyProductionReport' });
        }

        if (hasProductionDetailsReportPermission) {
            updatedReports.push({ label: 'Production >> Production Details Report', value: 'productionDetailsReport' });
        }

        if (hasMonthlyExpensePermission) {
            updatedReports.push({ label: 'Expense >> Monthly Expense Report', value: 'monthlyExpenseReport' });
        }

        if (hasDayBookPermission) {
            updatedReports.push({ label: 'Accounting >> Day Book', value: 'dayBook' });
        }

        if (hasCostBreakupPermission) {
            updatedReports.push({ label: 'Accounting >> Cost Breakup of Ledger', value: 'costBreakup' });
        }

        if (hasProfitAndLossReportPermission) {
            updatedReports.push({ label: 'Accounting >> Profit and Loss (P/L)', value: 'profitAndLossReport' });
        }

        if (hasPaymentSummaryPermission) {
            updatedReports.push({ label: 'Accounting >> Payment Summary', value: 'paymentSummary' });
        }

        if (hasStockAgingReportPermission) {
            updatedReports.push({ label: 'Inventory >> Stock Edging Report', value: 'stockAgingReport' });
        }

        if (hasRawMaterialInOutReportPermission) {
            updatedReports.push({ label: 'Inventory >> Raw Material In Out Report', value: 'rawMaterialInOutReport' });
        }

        if (hasItemRateHistoryPermission) {
            updatedReports.push({ label: 'Inventory >> Item Rate History Report', value: 'itemRateHistoryReport' });
        }

        if (hasWarehouseStockReportPermission) {
            updatedReports.push({ label: 'Inventory >> Warehouse Stock Report', value: 'warehouseStockReport' });
        } 

        updatedReports.sort((a, b) => a.label.localeCompare(b.label)); // Sort the array by label

        setAvailableReports(updatedReports); // Update the state with the new array
        // console.log(updatedReports)
        // eslint-disable-next-line
    }, [hasExpensePermission, hasSrWiseExpenseSummaryPermission, hasSalesPermission, hasAllSalesPermission, hasDeliveryPermission, hasLedgerStatementPermission, hasTrialBalancePermission, hasReconciliationPermission
        , hasOrderSheetPermission, hasSalesOrderPendingDeliveryPermission, hasDueReportPermission, hasCompanyWiseSalesReportPermission, hasSalespersonActivitesReportPermission
        , hasDetailsSalesItemSearchPermission, hasFreeSalesItemSearchPermission, hasDetailsPurchaseItemSearchPermission, hasExpectedStockReportPermission, hasStockUsagePredictionPermission
        , hasCollectionReportPermission, hasCompanyWiseProductPermission, hasMonthlyExpensePermission, hasDayBookPermission, hasCostBreakupPermission, hasProfitAndLossReportPermission,hasPaymentSummaryPermission, hasStockAgingReportPermission, hasRawMaterialInOutReportPermission, hasItemRateHistoryPermission, hasMonthlyProductionReportPermission, hasProductionDetailsReportPermission, hasWarehouseStockReportPermission]);

    useEffect(() => {
        if (query.get('type') === 'companyWiseSalesReport') {
            setCurrentReport({ label: 'Sales >> Company Wise Sales Report', value: 'companyWiseSalesReport' })
        }
        if (query.get('type') === 'dueReport') {
            setCurrentReport({ label: 'Sales >> Due Report', value: 'dueReport' })
        }

        if (query.get('type') === 'orderSheetReport') {
            setCurrentReport({ label: 'Sales >> Order Sheet Report', value: 'orderSheetReport' })
        }

        if (query.get('type') === 'ledgerStatement') {
            setCurrentReport({ label: 'Accounting >> Ledger Statement', value: 'ledgerStatement' })
        }
        if (query.get('type') === 'groupWiseBalanceReport') {
            setCurrentReport({ label: 'Accounting >> Group-wise Balance Report', value: 'groupWiseBalanceReport' })
        }
        if (query.get('type') === 'bankReconciliationStatement') {
            setCurrentReport({ label: 'Accounting >> Bank Reconciliation Statement', value: 'bankReconciliationStatement' })
        }

        if (query.get('type') === 'collectionReport') {
            setCurrentReport({ label: 'Sales >> Collection Report', value: 'collectionReport' })
        }

        if (query.get('type') === 'collectionReportV2') {
            setCurrentReport({ label: 'Sales >> Collection Report V2', value: 'collectionReportV2' })
        }

        if (query.get('type') === 'invoiceHistoryReport') {
            setCurrentReport({ label: 'Sales >> Invoice History Report', value: 'invoiceHistoryReport' })
        }

        if (query.get('type') === 'costOfGoodsSoldReport') {
            setCurrentReport({ label: 'Accounting >> Cost of goods sold', value: 'costOfGoodsSoldReport' })
        }
        if (query.get('type') === 'actualExpectedStockReport') {
            setCurrentReport({ label: 'Inventory >> Actual Expected Stock Status Report', value: 'actualExpectedStockReport' })
        }
        if (query.get('type') === 'detailPurchaseItemSearch') {
            setCurrentReport({ label: 'Detail Purchase Item Search', value: 'detailPurchaseItemSearch' })
        }
        if (query.get('type') === 'detailSalesItemSearch') {
            setCurrentReport({ label: 'Detail Sales Item Search', value: 'detailSalesItemSearch' })
        }
        if (query.get('type') === 'freeSalesItemSearch') {
            setCurrentReport({ label: 'Free Sales Item Search', value: 'freeSalesItemSearch' })
        }
        if (query.get('type') === 'productionDetailsReport') {
            setCurrentReport({ label: 'Production >> Production Details Report', value: 'productionDetailsReport' })
        }

        if (query.get('type') === 'generalSalesReportV2') {
            setCurrentReport({ label: 'Sales >> All Sales Report V2', value: 'generalSalesReportV2' })
        }
        if (query.get('type') === 'customerOutstandingAgingReport') {
            setCurrentReport({ label: 'Sales >> Customer Outstanding Aging Report', value: 'customerOutstandingAgingReport' })
        }
        if (query.get('type') === 'rawMaterialInOutReport') {
            setCurrentReport({ label: 'Inventory >> Raw Material In Out Report', value: 'rawMaterialInOutReport' })
        }
        // if (query.get('type') === 'monthlyProductionReport') {
        //     setCurrentReport({ label: 'Detail Sales Item Search', value: 'detailSalesItemSearch' })
        // }
        // eslint-disable-next-line
    }, [query.get('type')])


    return (
        <>
            <div className='card card-custom'>
                <div className='card-header'>
                    <div className="card-title">
                        <span className='text fw-bolder' style={{ marginLeft: '10px' }}>
                            Report Viewer
                        </span>
                        {/* {JSON.stringify(availableReports, null, 2)} */}
                    </div>
                </div>
                <div className='card-body pt-0'>
                    <Row>
                        <Col xs={8} md={10} lg={10}>
                            <Select
                                className="form-select-sm"
                                value={currentReport}
                                onChange={(e: any) => setCurrentReport(e)}
                                options={availableReports}
                                menuPosition="fixed"
                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                            />
                        </Col>
                        <Col xs={4} md={2} lg={2} className={"form-control-sm ps-0"}>
                            <button type="button" className="btn btn-primary btn-sm w-100 h-100">Generate</button>
                        </Col>
                    </Row>
                    <div className="mt-5">
                        {currentReport.value === 'generalExpenseReport' && hasExpensePermission && <ExpenseReport />}
                        {currentReport.value === 'monthlyExpenseReport' && hasMonthlyExpensePermission && <MonthlyExpenseReport />}
                        {currentReport.value === 'srWiseExpenseSummary' && hasSrWiseExpenseSummaryPermission && <ExpenseSummaryReport />}
                        {currentReport.value === 'salespersonWiseSales' && hasSalespersonWiseSalesPermission && <SalespersonWiseSalesReport />}
                        {currentReport.value === 'companyWiseProduct' && hasCompanyWiseProductPermission && <CompanyWiseProductReport />}
                        {currentReport.value === 'productWiseSales' && hasProductWiseSalesPermission && <ProductWiseSalesReport />}
                        {currentReport.value === 'generalSalesReport' && hasSalesPermission && <SalesReport />}
                        {currentReport.value === 'generalSalesReportV2' && hasAllSalesPermission && <SalesReportV2 />}
                        {currentReport.value === 'generalDeliveryReport' && hasDeliveryPermission && <DeliveryReport />}
                        {currentReport.value === 'ledgerStatement' && hasLedgerStatementPermission && <LedgerStatementReport />}
                        {currentReport.value === 'groupWiseBalanceReport' && (hasTrialBalancePermission || hasLedgerStatementPermission) && <GroupWiseBalanceReport />}
                        {currentReport.value === 'bankReconciliationStatement' && (hasReconciliationPermission || hasLedgerStatementPermission) && <BankReconciliationReport />}
                        {currentReport.value === 'dayBook' && hasDayBookPermission && <DayBookReport />}
                        {currentReport.value === 'paymentSummary' && hasPaymentSummaryPermission && <PaymentSummaryReport />}
                        {currentReport.value === 'costBreakup' && hasCostBreakupPermission && <CostBreakupReport />}
                        {currentReport.value === 'profitAndLossReport' && hasProfitAndLossReportPermission && <ProfitAndLossReport />}
                        {currentReport.value === 'orderSheetReport' && hasOrderSheetPermission && <OrderSheetReport />}
                        {currentReport.value === 'salesOrdersPendingDelivery' && hasSalesOrderPendingDeliveryPermission && <SalesOrdersPendingDeliveryReport />}
                        {currentReport.value === 'dueReport' && hasDueReportPermission && <DueReport />}
                        {currentReport.value === 'salesAdvanceReceiveReport' && hasSalesAdvanceReceivePermission && <SalesAdvanceReceiveReport />}
                        {currentReport.value === 'companyWiseSalesReport' && hasCompanyWiseSalesReportPermission && <CompanyWiseSalesReport />}
                        {currentReport.value === 'collectionReport' && hasCollectionReportPermission && <CollectionReport />}
                        {currentReport.value === 'collectionReportV2' && hasCollectionReportPermission && <CollectionReportV2 />}
                        {currentReport.value === 'salespersonActivitesReport' && hasSalespersonActivitesReportPermission && <SalespersonActivitesReport />}
                        {currentReport.value === 'salespersonPerformanceReport' && hasSalespersonActivitesReportPermission && <SalespersonPerformanceReport />}
                        {currentReport.value === 'invoiceHistoryReport' && hasInvoiceHistoryReportPermission && <InvoiceHistoryReport />}
                        {currentReport.value === 'customerEdgingReport' && hasCustomerEdgingReportPermission && <CustomerEdgingReport />}
                        {currentReport.value === 'customerOutstandingAgingReport' && (hasCustomerOutstandingAgingPermission || hasCustomerEdgingReportPermission) && <CustomerOutstandingAgingReport />}
                        {currentReport.value === 'itemWisePurchaseReport' && hasItemWisePurchaseReportPermission && <ItemWisePurchaseReport />}
                        {currentReport.value === 'detailSalesItemSearch' && hasDetailsSalesItemSearchPermission && <DetailSalesItemSearch />}
                        {currentReport.value === 'freeSalesItemSearch' && hasFreeSalesItemSearchPermission && <FreeSalesItemSearch />}
                        {currentReport.value === 'detailPurchaseItemSearch' && hasDetailsPurchaseItemSearchPermission && <DetailPurchaseItemSearch />}
                        {currentReport.value === 'costOfGoodsSoldReport' && hasCostOfGoodsSoldReportPermission && <CostOfGoodsSoldReport />}
                        {currentReport.value === 'costOfGoodsSoldReport' && hasCostOfGoodsSoldReportPermission && <CostOfGoodsSoldReport />}
                        {currentReport.value === 'expectedStockReport' && hasExpectedStockReportPermission && <ExpectedStockReport />}
                        {currentReport.value === 'actualExpectedStockReport' && hasExpectedStockReportPermission && <ActualExpectedStockReport />}
                        {currentReport.value === 'stockUsagePrediction' && hasStockUsagePredictionPermission && <StockUsagePrediction />}
                        {currentReport.value === 'monthlyProductionReport' && hasMonthlyProductionReportPermission && <MonthlyProductionReport />}
                        {currentReport.value === 'productionDetailsReport' && hasProductionDetailsReportPermission && <ProductionDetailsReport />}
                        {currentReport.value === 'stockAgingReport' && hasStockAgingReportPermission && <StockAgingReport />}
                        {currentReport.value === 'rawMaterialInOutReport' && hasRawMaterialInOutReportPermission && <RawMaterialInOutReport />}
                        {currentReport.value === 'itemRateHistoryReport' && hasItemRateHistoryPermission && <ItemRateHistoryReport />}
                        {currentReport.value === 'warehouseStockReport' && hasWarehouseStockReportPermission && <WarehouseStockReport />}
                        <ToastContainer />
                    </div>
                </div>
            </div >
        </>
    )
}
